import { initWebComponent } from '@experience/vite-plugin-wc-extract-styles';
import { createPinia } from 'pinia';
import { defineCustomElement } from 'vue';
import { createWebHistory, createRouter, type RouteRecordRaw } from 'vue-router';
import { createHead } from '@unhead/vue/client';

import App from '../App.ce.vue';
import { defaultRoutes } from '@/app/router';
import { createI18n } from '@experience/i18n';
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
import { handleRedirect } from '@/shared/lib/listingRedirect.ts';
import { configureApiClient } from '@/shared/api/configureApiClient';
import { client as experienceClient } from '@/shared/api/experience';
import { client as articlesClient } from '@/shared/api/articles';

const MF_NAME = 'experience-mf-listing';

export default initWebComponent({
  elementName: MF_NAME,
  stylesUrl: new URL(`${window.location.origin}/mfs/${MF_NAME}/extracted-styles.css`),
  dev: import.meta.env.DEV,

  defineElement: (styles) =>
    defineCustomElement(App, {
      styles,

      configureApp(app) {
        configureApiClient(experienceClient);
        configureApiClient(articlesClient);

        app.use(createPinia());

        const router = createRouter({
          history: createWebHistory('/'),
          routes: defaultRoutes as RouteRecordRaw[],
        });

        router.beforeEach((to, from, next) => {
          if (handleRedirect(to, next)) {
            return;
          }
          next();
        });

        app.use(router);

        const queryClient = new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 1000 * 60 * 3, // 3 минуты
            },
          },
        });
        app.use(VueQueryPlugin, { queryClient });

        const head = createHead();
        app.use(head);

        const i18n = createI18n({
          legacy: false,
          locale: 'ru',
        });
        app.use(i18n);
      },
    }),
});
